import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_INVITATIONS,
  FETCH_INVITATIONS_SUCCESS,
  FETCH_INVITATIONS_FAIL,
  ACCEPT_INVITATION,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_FAIL,
  REJECT_INVITATION,
  REJECT_INVITATION_SUCCESS,
  REJECT_INVITATION_FAIL,
} from "../actions/InvitationsActions";

import { invitationsApi } from "../api/InvitationsApi";

// Fetch Invitations
function* fetchInvitationsSaga() {
  try {
    
    const response = yield call(invitationsApi.fetchInvitations);
    yield put({ type: FETCH_INVITATIONS_SUCCESS, payload: { data: response.data } });
  } catch (error) {
    yield put({ type: FETCH_INVITATIONS_FAIL, payload: { error } });
  }
}

// Accept Invitation
function* acceptInvitationSaga(action) {
  try {
    const { invitationId, groupCartId } = action.payload;
    yield call(invitationsApi.acceptInvitation, invitationId, groupCartId);
    yield put({ type: ACCEPT_INVITATION_SUCCESS });
    if (action.onSuccess) action.onSuccess();
  } catch (error) {
    yield put({ type: ACCEPT_INVITATION_FAIL, payload: { error } });
  }
}

// Reject Invitation
function* rejectInvitationSaga(action) {
  try {
    const { invitationId, groupCartId } = action.payload;
    yield call(invitationsApi.rejectInvitation, invitationId, groupCartId);
    yield put({ type: REJECT_INVITATION_SUCCESS });
    if (action.onSuccess) action.onSuccess();
  } catch (error) {
    yield put({ type: REJECT_INVITATION_FAIL, payload: { error } });
  }
}

export default function* invitationsSaga() {
  yield takeLatest(FETCH_INVITATIONS, fetchInvitationsSaga);
  yield takeLatest(ACCEPT_INVITATION, acceptInvitationSaga);
  yield takeLatest(REJECT_INVITATION, rejectInvitationSaga);
}
